import { CompanyModel } from 'api/model';

// Samma normalisering som backendens fast tid-uppslag (ZipCodeAreaHelper.NormalizeAddressForMatching
// och NormalizeZipForPricing): allt blanksteg bort och gemener på adressen, mellanslag bort och
// känd rättning på postnumret.
const zipCorrections: Record<string, string> = { '86341': '85350' };

const normalizeAddress = (address: string | null | undefined) =>
  (address ?? '').replace(/\s/g, '').toLocaleLowerCase('sv-SE');

const normalizeZip = (zip: string | null | undefined) => {
  const normalized = (zip ?? '').replaceAll(' ', '');
  return zipCorrections[normalized] ?? normalized;
};

/**
 * Andra aktiva adresser med samma gatuadress + postnummer. Fast tid, tidsrapporten och
 * Riddermarks vyer matchar anläggningar på just det, så två aktiva adresser där kan inte
 * skiljas åt. I november 2026 fick "Riddermark Bil Online Sales" Logistik - Strängnäs adress,
 * och då försvann den fasta tiden på alla Logistiks sträckor.
 */
const findActiveCompaniesSharingAddress = (
  companies: CompanyModel[],
  address: string,
  zip: string,
  ownCompanyId: number | undefined
): CompanyModel[] => {
  const normalizedAddress = normalizeAddress(address);
  const normalizedZip = normalizeZip(zip);
  if (normalizedAddress === '' || normalizedZip === '') return [];

  return companies.filter(
    (c) =>
      c.active &&
      c.companyID !== ownCompanyId &&
      normalizeAddress(c.address) === normalizedAddress &&
      normalizeZip(c.zip) === normalizedZip
  );
};

export default findActiveCompaniesSharingAddress;
